// Small enough that one request stays well inside a gateway's timeout: a delete takes about a second.
export const BULK_DELETE_CHUNK = 10;

export interface BulkDeleteResult {
  deleted: number;
  count: number;
}

// A $batch answers 200 whatever its deletes did, so only the status of each one inside it counts.
export const deletedInBatchResponse = (response: unknown): number =>
  typeof response === 'string' ? (response.match(/HTTP\/1\.1 2\d\d\b/g) ?? []).length : 0;

export const chunkIds = (ids: number[], size = BULK_DELETE_CHUNK): number[][] => {
  const chunks: number[][] = [];
  for (let i = 0; i < ids.length; i += size)
    chunks.push(ids.slice(i, i + size));
  return chunks;
};

// One group at a time. A group that fails outright stops the run, since its deletes may or may not
// have happened - the caller reloads the list, which shows what is left.
export const deleteTicketsInChunks = async (
  ids: number[],
  sendChunk: (chunk: number[]) => Promise<unknown>,
  onProgress?: (done: number) => void,
  size = BULK_DELETE_CHUNK
): Promise<BulkDeleteResult> => {
  let deleted = 0;
  let done = 0;

  for (const chunk of chunkIds(ids, size)) {
    try {
      deleted += deletedInBatchResponse(await sendChunk(chunk));
    } catch {
      break;
    }
    done += chunk.length;
    onProgress?.(done);
  }

  return { deleted, count: ids.length };
};
